import { useContext, useState, useEffect } from "react";
import { useForm } from "react-hook-form";

//import { useHistory } from "react-router-dom";

import { classes } from "../../../utils/classes";
import { Link } from "../../ui-kit/Link";
import { AppContexts } from "../../../providers";


const LoginForm = (props) => {
  let authCtx = useContext(AppContexts.AuthContext);

  const { handleSubmit } = useForm();

  let [errors, setErrors] = useState([]);
  let [submitted, setSubmitted] = useState(false);
  let [completed, setCompleted] = useState(false);
  const [loading, setLoading] = useState(false);

  let [creds, setCreds] = useState({
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    password_confirmation: "",
    pword: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);

  let [valid, setValid] = useState({
    minLength: false,
    upper: false,
    lower: false,
    number: false,
    special: false,
    match: false,
  });

  useEffect(() => {
    document.title = "Sign Up - RueBaRue";
    let validation = Object.keys(valid).reduce((a, c) => {
      a[c] = false;
      return a;
    }, {});
    let { password, password_confirmation } = creds;

    if (password === "" && password_confirmation === "") {
      return setValid(validation);
    }

    if (password === password_confirmation) {
      validation.match = true;
    }

    if (password.length >= 8) {
      validation.minLength = true;
    }

    if (/[A-Z]+/g.test(password)) {
      validation.upper = true;
    }

    if (/[a-z]+/g.test(password)) {
      validation.lower = true;
    }

    if (/[0-9]+/g.test(password)) {
      validation.number = true;
    }

    if (/[!@#\$%\^&_]/g.test(password)) {
      validation.special = true;
    }

    setValid(validation);
  }, [creds]);

  const signup = () => {
    if (submitted) {
      return;
    }

    let errs = [];

    Object.keys(creds).map((k) => {
      if (k !== "pword") {
        if (!creds[k]) {
          errs.push(k);
        }
      }
    });

    if (errs.length !== 0) {
      setErrors({ msg: "Please fill out all fields", fields: errs });
      return;
    } else {
      setErrors(null);
    }

    // setSubmitted(true);
    setLoading(true);
    authCtx
      .signup(creds)
      .then((resp, err) => {
        setLoading(false);
        window.location.assign("/");
      })
      .catch((err) => {
        console.log(err);
        let { error, fields } = err;
        setErrors({ msg: error, fields: fields });
        setLoading(false);
      });
  };

  const update = (field, e) => {
    setCreds({ ...creds, [field]: e.target.value });

    if ((errors?.fields || []).includes(field)) {
      setErrors((errors?.fields || []).filter((k) => k !== field));
    }
  };

  return (
    <div className="page-box sign-in auth">
      <h2 className="uk-heading-small uk-margin-small-bottom">
        Signup for RueBaRue
      </h2>
      <div>
        <form className="uk-form-stacked" onSubmit={handleSubmit(signup)}>
          <div>
            Sign up to streamline guest communication and boost revenue effortlessly. Start for free—no credit card needed!
            <br />
            <br />
            Already have a company account? Ask your RueBaRue admin to invite you from the team page.
          </div>
          {errors?.msg && (
            <div className="uk-text-danger">
              <br />
              {errors.msg}
            </div>
          )}

          <div className="uk-margin uk-flex uk-flex-middle">
            <div
              className={classes(
                { error: (errors?.fields || []).includes("first_name") },
                "uk-width-1-2",
              )}
            >
              <label className="uk-form-label">First Name</label>
              <div className="uk-form-controls">
                <input
                  className="uk-input"
                  value={creds.first_name}
                  onInput={(e) => {
                    update("first_name", e);
                  }}
                />
              </div>
            </div>
            <div
              className={classes(
                { error: (errors?.fields || []).includes("last_name") },
                "uk-width-1-2",
                "uk-margin-left",
              )}
            >
              <label className="uk-form-label">Last Name</label>
              <div className="uk-form-controls">
                <input
                  className="uk-input"
                  value={creds.last_name}
                  onInput={(e) => {
                    update("last_name", e);
                  }}
                />
              </div>
            </div>
          </div>

          <div
            className={classes(
              { error: (errors?.fields || []).includes("email") },
              "uk-margin uk-width-1-2",
            )}
          >
            <label className="uk-form-label">Email</label>
            <div className="uk-form-controls">
              <input
                className="uk-input"
                value={creds.email}
                onInput={(e) => {
                  update("email", e);
                }}
              />
            </div>
          </div>

          <div className="uk-margin uk-flex uk-flex-middle">
            <div
              className={classes(
                { error: (errors?.fields || []).includes("password") },
                "uk-width-1-2",
              )}
            >
              <label className="uk-form-label">Password</label>
              <div className="uk-form-controls" style={{ position: "relative" }}>
                <input
                  className="uk-input"
                  type={showPassword ? "text" : "password"}
                  value={creds.password}
                  onInput={(e) => {
                    update("password", e);
                  }}
                  style={{ paddingRight: 36 }}
                />
                <span
                  onClick={() => setShowPassword((v) => !v)}
                  style={{
                    position: "absolute",
                    right: 10,
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    zIndex: 2,
                  }}
                  tabIndex={0}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? (
                    <img src="/images/eye-off.svg" alt="Hide" width={20} />
                  ) : (
                    <img src="/images/eye.svg" alt="Show" width={20} />
                  )}
                </span>
              </div>
            </div>

            <div
              className={classes(
                {
                  error: (errors?.fields || []).includes("password_confirmation"),
                },
                "uk-width-1-2",
                "uk-margin-left",
              )}
            >
              <label className="uk-form-label">Verify Password</label>
              <div className="uk-form-controls" style={{ position: "relative" }}>
                <input
                  className="uk-input"
                  type={showPasswordConfirm ? "text" : "password"}
                  value={creds.password_confirmation}
                  onInput={(e) => {
                    update("password_confirmation", e);
                  }}
                  style={{ paddingRight: 36 }}
                />
                <span
                  onClick={() => setShowPasswordConfirm((v) => !v)}
                  style={{
                    position: "absolute",
                    right: 10,
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    zIndex: 2,
                  }}
                  tabIndex={0}
                  aria-label={showPasswordConfirm ? "Hide password" : "Show password"}
                >
                  {showPasswordConfirm ? (
                    <img src="/images/eye-off.svg" alt="Hide" width={20} />
                  ) : (
                    <img src="/images/eye.svg" alt="Show" width={20} />
                  )}
                </span>
              </div>
            </div>

            <div className="uk-hidden">
              <input
                className="uk-input"
                value={creds.pword}
                onInput={(e) => {
                  update("pword", e);
                }}
              />
            </div>
          </div>

          <div className="uk-flex uk-inline-flex">
            <button
              className={classes(
                { disabled: submitted },
                "uk-button uk-button-# hms-btn hms-red-btn",
              )}
            >
              {loading ? <span data-uk-spinner="ratio: 0.5;" /> : ""}
              {" "}Sign Up
            </button>
          </div>

          <div className="uk-margin">
            <div className="uk-grid uk-child-width-1-2@s uk-grid-small" data-uk-grid>
              <ul className="password-validation uk-list">
                <li className={classes({ complete: valid.match })}>
                  ✅ Passwords must match
                </li>
                <li className={classes({ complete: valid.minLength })}>
                  ✅ At least 8 characters
                </li>
                <li className={classes({ complete: valid.upper })}>
                  ✅ At least one capital letter
                </li>
              </ul>
              <ul className="password-validation uk-list">
                <li className={classes({ complete: valid.lower })}>
                  ✅ At least one lowercase letter
                </li>
                <li className={classes({ complete: valid.number })}>
                  ✅ At least one number
                </li>
                <li className={classes({ complete: valid.special })}>
                  ✅ At least one of the following !@#$%^&_
                </li>
              </ul>
            </div>
          </div>

          <div className="uk-margin">
            Already have an account? <Link to="login">Login</Link>
          </div>
          <div className="uk-margin">
            By signing up, you agree to our{" "}
            <a href="https://www.ruebarue.com/privacy" target="_blank">
              Privacy Policy
            </a>{" "}
            and{" "}
            <a href="https://www.ruebarue.com/terms" target="_blank">
              Terms of Use
            </a>
            .
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginForm;
